import { each } from 'lodash';
import Swiper from 'swiper/bundle';
export default class CarouselStatusbar {
    constructor() {
        this.carousel = {
            elements: document.querySelectorAll('.carousel[data-carousel="statusbar-promo"]'),
        }

        each(this.carousel.elements, (carousel) => {
            this.createCarousel(carousel); // Init Carousel
        });
    }

    createCarousel(target) {
        var carousel = new Swiper(target, {
            speed: 500,
            slidesPerView: 1,
            disableOnInteraction: true,
            spaceBetween: 0,
            autoplay: {
                delay: 4000,
            },
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
                clickable: true,
            },
        });
    }
}